// removed by extract-text-webpack-plugin
module.exports = {"valign":"_3mHD2F7jqGBGmFkqhFbkk_","valignMiddle":"_2eZ6VhdAsvW7vf1jf6JEgu","valignBottom":"_2jhtMEI-fFOwo8ecd85twH"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Valign/style.css
// module id = 409
// module chunks = 39